import React from 'react'
import { Document } from '@react-pdf/renderer'
import { CoverPage, EventOverview, ExecutiveSummary } from './sections/Front'
import { ClinicalActivity, DayByDay, HealthSafety, Medicines, NhsImpact } from './sections/Clinical'
import { ControlRoomPerformance, Decisions, TreatmentLocations } from './sections/ControlRoom'
import {
  ActionPlan,
  Appendix,
  Lessons,
  OrganiserFeedback,
  PatientFeedback,
  StaffFeedback,
} from './sections/Back'

// The Post Event Report: a cover, then one numbered section per page group,
// in this order. Each major section starts its own <Page> (React-PDF draws
// one long page flow unreliably). Data comes from
// GET /events/:id/post-event-report; `pea` is the live PEA text from the
// event page so unsaved edits are included.
const ORDER = [
  ['executive', 'Executive summary', ExecutiveSummary],
  ['overview', 'Event and resourcing', EventOverview],
  ['clinical', 'Clinical activity', ClinicalActivity],
  ['days', 'Day by day', DayByDay],
  ['controlRoom', 'Control room performance', ControlRoomPerformance],
  ['treatment', 'Treatment locations', TreatmentLocations],
  ['nhsImpact', 'NHS impact', NhsImpact],
  ['medicines', 'Medicines administered', Medicines],
  ['healthSafety', 'Health and safety concerns', HealthSafety],
  ['decisions', 'Significant decisions', Decisions],
  ['patientFeedback', 'Patient compliments and complaints', PatientFeedback],
  ['organiserFeedback', 'Event organiser feedback', OrganiserFeedback],
  ['staffFeedback', 'Staff feedback', StaffFeedback],
  ['lessons', 'Lessons and recommendations', Lessons],
  ['actions', 'Action plan', ActionPlan],
  ['appendix', 'Methodology and data quality', Appendix],
]

const PostEventReportPDF = ({ data, pea, include, charts, chrome }) => {
  const sections = ORDER.filter(([key]) => include[key]).map(([key, title, Component], i) => ({
    key,
    title,
    Component,
    number: i + 1,
  }))
  return (
    <Document
      title={`Post Event Report - ${chrome.title}`}
      author={chrome.orgName}
      subject="Post event report"
      creator="AmbuNet"
      options={{ isEvalSupported: false }}
    >
      <CoverPage data={data} chrome={chrome} contents={sections} include={include} />
      {sections.map(({ key, Component, number }) => (
        <Component
          key={key}
          number={number}
          data={data}
          pea={pea}
          include={include}
          charts={charts}
          chrome={chrome}
        />
      ))}
    </Document>
  )
}

export default PostEventReportPDF
